import { computed } from "vue";
import { getToken } from "@/utils/cookie.js";
import { upload, updateUserAvatar } from "@/api/login";
import { useUserStore } from "@/stores/user";

/**
 * 用户头像上传逻辑（上传文件 → 更新用户头像接口 → 刷新用户信息）
 * 供 UserAvatar 组件及需要头像上传的页面复用
 */
export function useAvatarUpload() {
  const userStore = useUserStore();

  const uploadHeaders = computed(() => {
    const token = getToken();
    if (token) {
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };
    }
    return {};
  });

  const beforeUpload = () => true;

  const uploadImage = (param) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", param.file);
      upload(formData)
        .then((res) => {
          if (res && res.code === 200) {
            updateUserAvatar({ icon: res.data.downloadUrl })
              .then((i) => {
                if (i && i.code === 200) {
                  userStore.getUser();
                  param.onSuccess(res);
                  resolve(res);
                } else {
                  const error = new Error(
                    i?.message || i?.data?.message || "更新头像失败"
                  );
                  param.onError(error);
                  reject(error);
                }
              })
              .catch((error) => {
                const err =
                  error instanceof Error
                    ? error
                    : new Error(error?.message || "更新头像失败");
                param.onError(err);
                reject(err);
              });
          } else {
            const error = new Error(
              res?.message || res?.data?.message || "上传失败"
            );
            param.onError(error);
            reject(error);
          }
        })
        .catch((error) => {
          const errorMessage =
            error?.response?.data?.message || error?.message || "上传失败";
          const err = new Error(errorMessage);
          param.onError(err);
          reject(err);
        });
    });
  };

  const handleUploadError = (error) => {
    console.error("头像上传失败:", error);
  };

  return {
    uploadHeaders,
    beforeUpload,
    uploadImage,
    handleUploadError,
  };
}
